import i18n from '@/i18n'

const getters = {
  langs: () => {
    const { messages } = i18n

    return Object.keys(messages)
  }
}

export default getters
